module.exports = __webpack_public_path__ + "static/media/icon-chevron-up.2e88b36f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-chevron-up.svg
// module id = 727
// module chunks = 21